import { DefaultValues } from "react-hook-form";
import * as yup from "yup";
import {
  baseNomenclatureSchema,
  baseNomenclatureDefaults,
} from "../../../../common/nomenclatures/models/baseNomenclatureInputModel";

export const eventTypeCategorySchema = baseNomenclatureSchema.shape({
  sortOrder: yup.number().optional(),
});

export type IEventTypeCategoryInputModel = yup.InferType<
  typeof eventTypeCategorySchema
>;

export const eventTypeCategoryDefaults: DefaultValues<IEventTypeCategoryInputModel> =
  {
    ...baseNomenclatureDefaults,
    sortOrder: 0,
  };
